import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const CategoryForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        categoryName: { name: 'categoryName', value: data?.CATEGORY_NAME || '', isRequired: true, error: '' },
        categoryCode: { name: 'categoryCode', value: data?.CATEGORY_CODE || '', isRequired: true, error: '' },
        description: { name: 'description', value: data?.NOTE || '', isRequired: false, error: '' },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Category Name {state.categoryName.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.categoryName.name}
                        value={state.categoryName.value}
                        onChange={handleChange}
                        placeholder="Enter category name"
                        className={`form-control ${state.categoryName.error ? 'is-invalid' : ''}`}
                    />
                    {state.categoryName.error && <div className="invalid-feedback">{state.categoryName.error}</div>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Category Code {state.categoryCode.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.categoryCode.name}
                        value={state.categoryCode.value}
                        onChange={handleChange}
                        placeholder="Enter unique code"
                        className={`form-control ${state.categoryCode.error ? 'is-invalid' : ''}`}
                    />
                    {state.categoryCode.error && <div className="invalid-feedback">{state.categoryCode.error}</div>}
                </div>

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Any additional notes"
                    />
                </div>

                
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white"  href={constant.Authedcomponent.listScheduleCategoryMasterData.url}>Cancel</a>
            </div>
        </form>
    );
};

export default CategoryForm;
